import React from 'react';
import PropTypes from 'prop-types';
import iconClose from '../../static/img/cancel.png';

const CardHeader = ({ icon, text, handleClose }) => (
  <div className="card-header">
    <div className="card-type">
      <span className={`card-type_icon ${icon}`} />
      <h4 className="card-type_header">{text}</h4>
    </div>
    <button className="card-close" onClick={e => e.stopPropagation() || handleClose()}>
      <img className="card-close_icon" src={iconClose} alt="Close" />
    </button>
  </div>
);

CardHeader.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
};

CardHeader.defaultProps = {
  icon: '',
  text: '',
};

export default CardHeader;
